export const apiUrl =
  `${process.env.REACT_APP_API_URL}/admin` || 'http://localhost:5500/api/admin';
